<template>
  <div>
    <section class="hero is-small is-light">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Kaffee Dashboard</h1>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="level">
          <div class="level-left">
            <!-- dummy -->
          </div>
          <div class="level-right">
            <p class="level-item">
              <button
                v-if="isAdmin"
                class="button is-primary"
                @click="createAccount()"
              >Neuer Eintrag</button>
            </p>
          </div>
        </div>
        <b-table :data="tableData || []" :loading="isLoading" mobile-cards>
          <template slot-scope="props">
            <b-table-column field="nickname" label="Nickname">{{ props.row.nickname }}</b-table-column>

            <b-table-column field="amount" label="Anzahl Kaffee's">{{ props.row.amount }}</b-table-column>

            <b-table-column
              field="pricePerCoffee"
              label="Preis pro Kaffee"
            >{{ props.row.pricePerCoffee | localCurrencyEur }}</b-table-column>

            <b-table-column
              field="totalPrice"
              label="Summe"
            >{{ props.row.totalPrice | localCurrencyEur }}</b-table-column>

            <b-table-column field="updatedAt" label="Letzte Änderung" centered>
              <span class>{{ props.row.updatedAt | localTime}}</span>
            </b-table-column>

            <b-table-column custom-key="actions" label="Aktion">
              <div class="buttons">
              <button class="button" :disabled="props.row.amount <= 0" @click="pay(props.row)">
                <b-icon pack="fas" icon="euro-sign"></b-icon>
                  <span> Bezahlen</span>
                </button>

              <button v-if="isAdmin" class="button" @click="edit(props.row)">
                <b-icon pack="fas" icon="edit" size="is-small"></b-icon>
                <span> Bearbeiten</span>
              </button>
              </div>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon pack="far" icon="frown" size="is-large"></b-icon>
                </p>
                <p>Keine Einträge</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </section>
  </div>
</template>

<script>
import { Auth, Hub } from "aws-amplify";
import Store from "../store";
import EditForm from "../components/EditForm.vue";
import PaymentForm from "../components/PaymentForm.vue";
import moment from "moment";
import userHelper from "../components/user-helper";

export default {
  name: "dashboard",
  components: {
    EditForm,
    PaymentForm
  },
  data() {
    return {
      isLoading: false
    };
  },
  filters: {
    localTime: function(value) {
      const d = moment(parseInt(value));
      return d.format("DD.MM.YYYY HH:mm:ss");
    },
    localCurrencyEur: function(value) {
      return value
        ? value.toLocaleString(moment.locale(), {
            style: "currency",
            currency: "EUR",
            currencyDisplay: "symbol"
          })
        : "";
    }
  },
  computed: {
    user() {
      return Store.state.user;
    },
    isAdmin() {
      return userHelper.isAdmin(this.user);
    },
    config() {
      return Store.state.configuration;
    },
    tableData() {
      return Store.state.coffees.map(item => {
        const pricePerCoffee = this.config.pricePerCoffee;
        const totalPrice = pricePerCoffee
          ? parseFloat(pricePerCoffee) * item.amount
          : null;
        return {
          ...item,
          pricePerCoffee,
          totalPrice
        };
      });
    }
  },
  methods: {
    edit(data) {
      console.log(data);
      this.$modal.open({
        parent: this,
        component: EditForm,
        hasModalCard: true,
        props: { ...data, formMode: "edit" }
      });
    },
    pay(data) {
      console.log(data);
      this.$modal.open({
        parent: this,
        component: PaymentForm,
        hasModalCard: true,
        props: { ...data, pricePerCoffee: this.config.pricePerCoffee}
      });
    },
    createAccount() {
      this.$modal.open({
        parent: this,
        component: EditForm,
        hasModalCard: true,
        props: { nickname: "", amount: 0, formMode: "create" }
      });
    }
  },
  async mounted() {
    this.isLoading = true;
    try {
      if (!Store.state.configuration) {
        console.log('Fetch config')
        await Store.dispatch("fetchConfiguration");
      }
      await Store.dispatch("fetchCoffees");
    } catch (err) {
      console.log(err);
    }
    this.isLoading = false;
  }
};
</script>

